<template>
  <v-app v-if="noAuth">
    <v-main>
      <v-container class="pt-16">
        <RouterView />
      </v-container>
    </v-main>
  </v-app>
  <v-app v-else-if="user" :theme="configuration.Theme.toLowerCase()">
    <TopBar />
    <NavigationDrawer />
    <v-main>
      <v-container class="pt-16">
        <RouterView />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'
import { storeToRefs } from 'pinia'
import TopBar from '@/components/TopBar.vue'
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import { useUserConfigStore } from './stores/userConfig'
import { useRoute } from 'vue-router'
import { computed, watch } from 'vue'
import { useSentry } from '@/composables/useSentry'
import { useNetworkNotifications } from '@/composables/useNetworkNotifications'

const daisuke = daisukeAuth0Store()
const { user } = storeToRefs(daisuke)
const { setUser, setTag } = useSentry()

watch(
  user,
  (u) => {
    if (u) {
      setUser({ id: u.ID_USER })
      if (u.orgId) setTag('tenant_id', u.orgId)
    } else {
      setUser(null)
    }
  },
  { immediate: true },
)

// This store sets the language and the zapan language
const userConfigStore = useUserConfigStore()
const { configuration } = storeToRefs(userConfigStore)

const route = useRoute()
const routeLogin = route.meta?.login

const noAuth = computed(() => {
  return (routeLogin === 'optional' && !user) || routeLogin === 'none'
})

useNetworkNotifications()
</script>
